const options = [
  {
    key: 'home',
    label: 'home',
    leftIcon: 'ion-android-mail',
  }
];
export default options;
